import { Cross } from "@monsterindia/global-ui-components";
import { FC, useEffect, useState } from "react";

import { getCMSBanner } from "../../utils";

type MsiteCloseIconProps = {
  fetchAPI: any;
  closeApop: () => void;
};

export const MsiteCloseIcon: FC<MsiteCloseIconProps> = ({
  fetchAPI,
  closeApop,
}) => {
  const [bannerImage, setBannerImage] = useState<string | null>(null);

  useEffect(() => {
    const getBanner = async () => {
      const res = await getCMSBanner(
        fetchAPI,
        "vcf",
        "l1_pop_triumph_banner",
        "rexmonster",
      );
      const data = res.data.triumph_banner[0].banner_image || null;
      setBannerImage(data);
    };
    getBanner();
  }, []);

  return (
    <div className="l1-relative">
      {window.innerWidth < 768 && closeApop ? (
        <button
          onClick={closeApop}
          className="l1-absolute l1-right-0 l1-ml-auto l1-mr-2 l1-mt-2 l1-size-6"
          type="button"
        >
          <Cross width={24} height={24} className="l1-fill-content-primary" />
        </button>
      ) : null}
      {bannerImage && (
        <img src={bannerImage} alt="avatar" className="l1-size-full" />
      )}
    </div>
  );
};
